module.exports = '<svg width="33" height="32" viewBox="0 0 33 32"><path d="M26.697 2.13v8.139l-3.08-2.491-3.08 2.491V3.671c0-.567-.446-.914-.996-.778l-3.111.778L1.993.061C.894-.212.001.482.001 1.618v22.59c0 1.136.86 2.376 1.924 2.777l12.583 4.717c1.062.398 2.785.398 3.846 0l12.583-4.717c1.062-.4 1.922-1.641 1.922-2.777V1.618c0-1.136-.893-1.832-1.992-1.557l-3.173.795c-.55.136-.996.709-.996 1.275z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/open-book-1.js
// module id = 1315
// module chunks = 14